export default "__VITE_ASSET__nHYxZXaB__"